var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "url(#pattern0_641_452)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_641_452",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_641_452",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_641_452",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAABKtJREFUWIW9l1tsFGUYhp9vdnqgLS20hd1Ou2WB0ikqQgQFJSYomDRihKAkRGIJ0USjVyZqDTeEaDSIhxu9MIRojBoTo7Fa8Q7BgKkIhmiaHmhhe9rdNi2CLbBtd/7Pi7pQetyWw3u3833/+z47mZnv/4UUVVjozrWzqFSjm0SslaguRsgDEqBRRboFOYOan2yuHO3s7Lyaiq9M1+Bf5C7GUC1QBcxJkfcKoocS4nunt60hOlWjbzqnubmFnws8A6SlGM5Ir6y1VF+am1eQPbAs9CvRqJmoccI7UFJSXpywrbRYuDHsLFp+nzGmboYAY3VKbOvp6PmGtrEFa+yFQOlddydETqqnx0tLV8yPtDX8KeiBmwgHWKMJ7/dQKDRvSoBAqCKE8Y4AjkDxkA5+CJCfm7YP+OtmCASpC4fD/ZMChEKhTDz9EWHhqGW7nGD51vr6+iGfMbuAodnF6/vRjqZtgOc4S4OMevauAcS9jDeBe8YuNSqf+P1LF3Z1nT0DvDXD5GEReSHW0fwqYPwl7nPGZ7f6g+6+ZIPAyKsmhkYgfSIXgZpoR9NW2GAHgtETwAPTRgv9GN0R62w+DEigtGIvqnuT/xefLI+FG8MWgKXsmSwcQGFLoLS8Co4mEG83EJ8m/pyIWRvrbD7s99+b7Q9WfDsqHCATT6sBZP6SJXkZw2ldQPY0ppcsL7EiEmntCJS4ryG8OwlunQ55W7q7W3sKFy0vso2pAe6f2C/HsdKH7coUwgHyjGV/Ckiss+kDhRPjooUvczLMhu7u1p7i4mWrbGNOThI+4mcPbLYQa2MK4SMSNgZKKl4GPESrgIFkNsr+7vamZ1taWgaLStxKz7KOASVT2hnWW6K6MmUAANH9juO63e3N50CrgbgiO2OdTW8AWhQsf0WFWiB3OisVWSeBoNsDLJgRBFoX63AehqMJx1mdFYmcvgL4AkH3I+DFGRh1WEDezMIBZJ0/GHsd4P9wHMctA3bP0Khg3CxIGQHd6y8t35T8HYk0NaVLehGiu1CtJbWvpk8CQbcXKJglx1XgY5+Rg11djc2jC6FQaF7cpD+JYTsijwEZ41YrPRIIun8Aa2YJMFrnRKkVS7+JtDf/Blyb/46zOsuzL28Uo9sRtnHttdc6KSp1D6ry/C0AGK2owg+iWpOTaY60tLQMJgv5ZWW5aXH7CRHzlIock6ISd6cKX9xigOsS+lF+VpWaOXb8cDgcvnhDOb+sLDd90NcNZN42iOsaFuSYYr5Pl4yv2tv//sd39cKFwZy8gjKQVXcAwAcsAXncwxsa+Lfvl5Fp6GM/kLgDAEnFxbYOJYnov9jXm523YL7Ag3ciXdAD0bam72DUjmiOL76Hm9z3pajT2Rnmxh1RUsXFFeWepSeAwtsUHlPR9SODbEQ3fIq7uhqbRaQS6L0d4WKZR0eHjwMAiLY3nvYZWQ9afwvDT6nFQ9G2sw1jCxMezfr7e/tyc0KfGWs4S0Z2NLMdWnFReS8n06vqOH92wrs67eHUcVzX+KgGdpD64fSSwtc+z347Eqlvn6pxWoCk8svKctMG7c0Ij4jqSpQQwjzAA/pAO0XlpFoct83l2lSP5/8BDzzCCCzIjIMAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart1);
export default __webpack_public_path__ + "static/media/pie-chart 1.df7c453f9a7e2e75f5e0d8c3fba3b5f8.svg";
export { ForwardRef as ReactComponent };